import React from "react";

const CardSection = ({ title, children, footer }) => {
  return (
    <div className="border-primary-light-200 mx-auto w-full rounded-lg border bg-monochrome-25">
      <div className="flex items-center justify-between px-4 py-3">
        <h3 className="text-medium font-semibold">{title}</h3>
      </div>
      <div className={`rounded-lg bg-white px-4 py-3 ${footer && "shadow-md"}`}>
        {children}
      </div>
      {footer && <div className="px-4 py-3">{footer}</div>}
    </div>
  );
};

export default CardSection;
